import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'core/gd-form/form/form-modal/form-modal';
import FormSelect from 'core/gd-form/form-element/select-new/select-new';

module.exports = class ModalActionProgress extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            item: PropTypes.object,
            onSubmit: PropTypes.func.isRequired,
        })
    }

    constructor(props) {
        super(props);

        const { item } = this.props.params;
        const initFormData = {
            progress: item && item.progress ? item.progress : 0
        };

        const formStructure = {
            fields: {
                progress: {
                    type: 'select',
                    isRequired: false,
                    onUserChange: this.onProgressInputChange
                },
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);

        this.state = {
            progress: initFormData.progress
        }
    }

    onProgressInputChange = () => {
        const progress = this.form.getValue("progress");
        this.setState({
            progress: progress
        })
    }

    onSubmit = (result) => {
        this.props.params.onSubmit(result.progress)
    }

    onSelectorItemClick = (value) => {
        this.onSubmit({
            progress: value
        })
    }

    render() {
        const presetItems = [];
        [0,10,20,30,40,50,60,70,80,90,100].map(val=>{
            presetItems.push({value:val, label:val});
        });

        const allOptions = [];
        for (let i = 0; i <= 100; i++) {
            allOptions.push({
                label: i + ' %',
                value: i
            });
        }

        return (
            <div className="tbl">
                <div className="row presets">
                    <div className="col-1">Presets</div>
                    <div className="col-2">
                        {presetItems.map((obj, key)=><div key={key} className="preset-item" onClick={this.onSelectorItemClick.bind(this, obj.value)}>{obj.label}</div>)}
                    </div>
                </div>

                <div className="row custom-value">
                    <div className="col-1">PROGRESS</div>
                    <div className="col-2">
                        <Form form={this.form} submitLabel="Save" >
                            <FormSelect form={this.form}
                                        name="progress"
                                        options={allOptions}
                                        placeholder="Select..."
                                        searchable={false} />
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
};